// Check if filename has a known file extension (letters after last dot)
// DICOM files often named by UID like "1.2.840.113999..." - dots with digits, not extension
export const hasKnownFileExtension = (fileName: string): boolean =>
  /\.[a-zA-Z]{2,10}$/.test(fileName);
